export const budget = {
  min: 0,
  max: 1000000,
};

export const marks = [
  {
    value: budget.min,
    label: '$ 0',
  },
  {
    value: budget.max,
    label: '$ 1,000,000',
  },
];
